import Icon from 'Components/Icon';
import PropTypes from 'prop-types';
/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { NavLink } from 'react-router-dom';
import { withLastLocation } from 'react-router-last-location';
import History from 'Store/history';

import { classnames } from 'Utils/classnames';
import { decimalFormatter } from 'Utils/decimalFormatter';
import EnvironmentManager from 'Utils/environmentManager';
import { customerServiceNumberDial } from 'Utils/getCustomerServicePhone';
import { withMixpanel } from 'Utils/mixpanel';
import UserProfile from '../UserProfile';
import NoSSR from 'Components/NoSSR';
import { toggleSideMenu, updateUserBalance } from 'Store/actions';
import { useMediaQuery } from 'react-responsive';

const HeaderSimplePage = props => {
  const { color, title, subTitle, icon, callCustomerService, lastLocation, h1tag,  tabs, hideBackButton, selectedTabId, customButton, customComponent, showBalance, helpButton, helmet, userAgent, showSideMenu, scrollY = false, customBackFunc, hideOnMobile, isDigitalGames, wrapperFull, noLineHeight, alignLeft, customClass } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const { data: { balance }, isAuthenticated } = useSelector(state => state.auth);
  const balanceSplitter = decimalFormatter(balance).split(',');
  const raffleHaderHelp = EnvironmentManager.getMessageText({ key: 'title_raffle_help_icon' }) || 'Yardım';
  const isMobil = useMediaQuery({
    query: '(max-width: 768px)'
  });
  const headerClass = classnames({
    'header-simple-page': true,
    'hide-header': hideOnMobile && isMobil,
    [`header-simple-page--${color}`]: color,
    [customClass || 'customClass']: customClass,
  });
  const auth = useSelector(state => state.auth);
  const tribun = useSelector(state => state.tribun);
  const unreadAnnouncementsCount = useSelector(state => state.announcement.seenAnnouncements.unseenNewsCount);
  const isDesktop = props.userAgent?.device?.type === 'desktop';

  // eslint-disable-next-line react/prop-types
  const tjkKuponlarımPath = props?.location?.pathname;

  const { data } = auth;
  const { digitalGamesBalance = 0 } = data || {};
  const digitalGamesBalanceSplitter = decimalFormatter(digitalGamesBalance).split(',');

  useEffect(()=> {
    let timeout;
    if (showBalance && isAuthenticated) {
      timeout = setTimeout(() => {
        dispatch(updateUserBalance());
      }, 500);
    }

    return () => {
      clearTimeout(timeout);
    };

  }, [showBalance, isAuthenticated]);
   
  return (
    <div className={ headerClass }>
      { !(hideOnMobile && isMobil) && <div style={ { maxWidth: wrapperFull && 'unset'  } } className="wrapper">
        { !hideBackButton ? <button
          className="btn btn--back"
          onClick={ () => {

            if (customBackFunc) { // NSoft oyunları için back fonksiyonu oyun sayfasında yönetilmekte.
              customBackFunc();
              return;
            }
            if (History.location.pathname === '/sanal-bahis') {
              if (window.history.length > 1) {
                History.goBack();
              } else {
                History.push('/');
              }
              return;
            }
            // Şans Oyunları iframe içerisinde browser back kullanımı oyun içerisine müdahale ediyor o nedenle eklenmiştir.
            if (History.location.pathname === '/sans-oyunlari') {
              if (window.history.length > 1) {
                History.goBack();
              } else {
                History.push('/');
              }
              return;
            }
            if (History.location.pathname === '/dunya-kupasi') {
              History.push('/');
              return;
            }

            if (History.location.pathname.includes('sans-oyunlari/') && !History.location.pathname.includes('sans-oyunlari/yardim/')) {
              if (History.location.pathname.includes('/sans-oyunlari/esya-piyangosu/bilet-detay')) {
                History.push('/sans-oyunlari/esya-piyangosu/biletlerim');
                return;
              } else if (History.location.pathname.includes('/sans-oyunlari/esya-piyangosu/detay')) {
                History.push('/sans-oyunlari/esya-piyangosu');
                return;
              } else {
                if (lastLocation)
                  History.push('/sans-oyunlari');
                else
                  History.push('/');
                return;
              }
            }

            if (!lastLocation || (lastLocation && lastLocation.pathname === '/sans-oyunlari/esya-piyangosu')) {
              
              if (History.location.pathname?.includes('esya-piyangosu')) {
                if (History.location.pathname?.includes('cekilis')) {
                  History.push('/');
                } else {
                  History.push('/sans-oyunlari/esya-piyangosu');
                }
              } else {
                History.push('/');
              }
            } else {
              if (History.location.pathname?.includes('sans-oyunlari/esya-piyangosu'))
                History.push('/');
              else
                History.goBack();
            }
          } }
        /> : null }

        { helpButton ? <button style={ { backgroundColor: 'transparent', borderRadius: 'unset', width: 'unset' } } title={ raffleHaderHelp } className="btn btn--help"
          onClick={ () => {
            props.mixpanel.track('Click Help Menu', {
              'Page Name': 'İletişim İzni'
            });
            history.push('/yardim/yardim-konulari/esya-piyangosu');
          } }
        >   <span>{ raffleHaderHelp }</span> </button> : null }

        { tabs?.length
          ? <div className='tab-bar'>
            { tabs.map(item => {
              const itemClass = classnames({
                'tab-bar__item': true,
                'tab-bar__item__selected': selectedTabId === item.id
              });
              return (
                <div className={ itemClass } key={ item.url }>
                  { (selectedTabId && selectedTabId === item.id) ? (<h1>
                    <NavLink replace={ item.replace } to={ item.url }>
                      { item.title }
                    </NavLink>
                  </h1>) : (<h2>
                    <NavLink replace={ item.replace } to={ item.url }>
                      { item.title }
                    </NavLink>
                  </h2>) }
                </div>
              );
            }
            ) }
          </div>
          : tjkKuponlarımPath?.includes('/tjk/at-yarisi-kuponlari')
            ? !subTitle ? (h1tag ? <h1 className={ scrollY ? 'scroll-y' : '' }>{ title }</h1> : <h2>{ title }</h2>)
              : <div className={ classnames({ 'tab-bar__other-wrapper': true, 'align-left': alignLeft }) }>
                { h1tag
                  ? <h1 style={ { lineHeight: (noLineHeight && !isMobil) && 'unset' } }>{ title }</h1>
                  : <h2 style={ { lineHeight: (noLineHeight && !isMobil)  && 'unset' } }>{ title }</h2> }
                <span>{ subTitle }</span>
              </div>
            : !subTitle ? (h1tag ? <h1 className={ scrollY ? 'scroll-y' : '' }>{ title }</h1> : <h2>{ title }</h2>)
              : <div className='tab-bar__subtitle-wrapper'>
                { h1tag
                  ? <h1>{ title }</h1>
                  : <h2>{ title }</h2> }
                <span>{ subTitle }</span>
              </div>
        }
        {
          customComponent && <div className='header-simple-page__custom-component'>
            { customComponent ?? null }
          </div>
        }

        { showBalance && isAuthenticated
          && <div className='header-balance__balance-wrapper'>
            <div className="header-balance__info__value">
              <div className="header-balance__info__value__lira">
                { `${isDigitalGames ? digitalGamesBalanceSplitter[0] : balanceSplitter[0]}` }
              </div>
              { balance?.toString().indexOf('.') > 0 ? <div className="header-balance__info__value__penny">
                { `,${isDigitalGames ? digitalGamesBalanceSplitter[1] : balanceSplitter[1]}` }
              </div> : <div className="header-balance__info__value__penny">
                { ',00' }
              </div> }
              <div className="header-balance__info__value__rectangle">&nbsp;
                <span className='header-balance__info__tl-text'>₺</span>
              </div>
            </div>
          </div>
        }

        { icon && (
          callCustomerService ? (
            <a href={ customerServiceNumberDial } title="Bilyoner">
              <div className="header-simple-page__icon" onClick={ icon.onClick }>
                <Icon iconName={ icon.name } />
              </div>
            </a>
          ) : (
            <div className="header-simple-page__icon" onClick={ icon.onClick }>
              <Icon iconName={ icon.name } />
            </div>)
        ) }

        { customButton ?? null }

        { /* side menunun acılması istenen sayfalarda userAgent, helmet ve showSideMenu verilmeli */ }
        { showSideMenu && !isDesktop && <div className='hamburgerButton' onClick={ () => {
          props.mixpanel.track('Click Hamburger Menu', {
            'Click Point': 'Hamburger Icon'
          });
          dispatch(toggleSideMenu());
        } }>
          <Icon iconName={ 'svgHamburgerWhite' }  />
        </div> }
      </div> }
      { showSideMenu && auth && userAgent && helmet && !isDesktop
      && <NoSSR>
        <UserProfile
          auth={ auth }
          platform={ userAgent?.os?.name }
          device={ userAgent?.device }
          helmet={ helmet }
          tribun={ tribun }
          unreadAnnouncementsCount={ unreadAnnouncementsCount }
          dontRequest
        />
      </NoSSR>
      }

    </div>
  );
};

HeaderSimplePage.propTypes = {
  color: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  page: PropTypes.string,
  icon: PropTypes.shape({
    name: PropTypes.string,
    onClick: PropTypes.func
  }),
  callCustomerService: PropTypes.bool,
  lastLocation: PropTypes.object,
  tabs: PropTypes.array,
  selectedTabId: PropTypes.string,
  hideBackButton: PropTypes.bool,
  customButton: PropTypes.node,
  h1tag: PropTypes.bool,
  customComponent: PropTypes.node,
  showBalance: PropTypes.bool,
  helpButton: PropTypes.string,
  mixpanel: PropTypes.object,
  helmet: PropTypes.object,
  userAgent: PropTypes.object,
  showSideMenu: PropTypes.bool,
  scrollY: PropTypes.bool,
  wrapperFull: PropTypes.bool,
  customBackFunc: PropTypes.func,
  hideOnMobile: PropTypes.bool,
  isDigitalGames: PropTypes.bool,
  noLineHeight: PropTypes.bool,
  alignLeft: PropTypes.bool,
  customClass: PropTypes.string
};

export default withLastLocation(withMixpanel(HeaderSimplePage));
